import React, { useState } from 'react';
import { connect } from 'react-redux';
import { selectIsWindowMode } from '@ff-os/pdp-shared-redux/slices/globalSlice';
import { AspectRatio } from '@ff-os/shared-react/components/aspect-ratio/AspectRatio';
import { RerenderAfterHydration } from '@ff-os/shared-react/components/rerender-after-hydration/RerenderAfterHydration';
import { WindowStackProvider } from '@ff-os/shared-react/context/window-stack/WindowStack';
import { useHas3d } from '@ff-os/shared-react/hooks/useHas3d';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { ArPreviewStatus } from '@ff-scene-plugins/gift-redux/slices/uiSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectIsGiftWindowOpen } from './_redux-ui';
import { selectConfig3dOpenByDefault, selectHasConfig3d, selectShowArStatus } from './_redux-variants';
import { Controls3d } from './controls3d/Controls3d';
import { DesignCredits } from './preview/DesignCredits';
import { GiftPreview2d } from './preview/GiftPreview2d';
import { GiftPreview3d } from './preview/GiftPreview3d';
import styles from './GiftPreviewUi.module.scss';

const _GiftPreviewUi = ({
    has3dConfig,
    showArStatus,
    open3dByDefault,
    isWindowOpen,
    isWindowMode
}: Props) => {

    const isMobile = useMobile();
    const has3d = useHas3d(has3dConfig);

    const [show3d, set3d] = useState(has3d && open3dByDefault);

    const hidePreview = (isMobile && isWindowOpen) || (isWindowMode && isWindowOpen);
    const GiftPreview = show3d ? GiftPreview3d : GiftPreview2d;

    return (
        <RerenderAfterHydration>
            <WindowStackProvider>
                <div className={styles.default}>
                    <AspectRatio width={1} height={1}>
                        {has3d && (
                            <Controls3d
                                show3d={show3d}
                                set3d={set3d}
                                showArStatus={showArStatus} />
                        )}

                        {!hidePreview && (
                            <>
                                <GiftPreview />
                                <DesignCredits />
                            </>
                        )}
                    </AspectRatio>
                </div>
            </WindowStackProvider>
        </RerenderAfterHydration>
    );
};

type Props = {
    has3dConfig: boolean;
    showArStatus: ArPreviewStatus;
    open3dByDefault: boolean;
    isWindowOpen: boolean;
    isWindowMode: boolean;
};

const mapStateToProps = (state: GiftPdpState) => ({
    has3dConfig: selectHasConfig3d(state),
    showArStatus: selectShowArStatus(state),
    open3dByDefault: selectConfig3dOpenByDefault(state),
    isWindowOpen: selectIsGiftWindowOpen(state),
    isWindowMode: selectIsWindowMode(state)
});

export const GiftPreviewUi = connect(
    mapStateToProps
)(_GiftPreviewUi);